import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // or <a href="/signup"> if not using react-router
import API from '../api';
import '../LiveAlertScroller.css'; // we’ll add some CSS separately

function LiveAlertScroller() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    loadAlerts();
    const interval = setInterval(loadAlerts, 15000); // refresh every 15s
    return () => clearInterval(interval);
  }, []);

  const loadAlerts = async () => {
    try {
      const res = await API.get('api/live-alerts');
      setAlerts(res.data || []);
    } catch (err) {
      console.error("Alert fetch failed", err);
    }
  };

  return (
    <div className="live-alert-box">
      <h4 className="text-center mb-3">Top Live Stock Alerts</h4>

      {alerts.length > 0 ? (
        <div className="alert-scroller">
          <ul>
            {alerts.map(a => (
              <li key={a.id}>
                <span>{a.message}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-center">No live alerts at the moment</p>
      )}

      <div className="alert-footer">
        <a href="/signup" className="see-more-link">
          See more alerts →
        </a>
      </div>
    </div>
  );
}

export default LiveAlertScroller;
